export default {
  getListOffersCombo: state => state.listOffersCombo,
  getOptionsOffersCombo: state => state.optionsOffersCombo,
  getPaginationOffersCombo: state => state.paginationOffersCombo,
  getCurrentPage: state => state.currentPage,
  getCombosFilter: state => state.combosFilter
}
